import {
  RESET_PASSWORD,
  TEMPORARY_PASSWORD_CONFIRMED,
  RESET_PASSWORD_FAIL,
  CLEAR_EMAIL,
} from "../actions/types";

const initialState = {
  userEmail: "",
  isAuthenticated: null,
  verified: false,
  redirected: false,
  temporaryPassword: false,
  message: "",
  loading: true,
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case RESET_PASSWORD:
      return {
        ...state,
        userEmail: payload,
        loading: false,
      };
    case TEMPORARY_PASSWORD_CONFIRMED:
      return {
        ...state,
        temporaryPassword: payload,
        message: payload.msg && payload.msg !== "" ? payload.msg : "",
        loading: false,
      };
    case RESET_PASSWORD_FAIL:
      return {
        ...state,
        isAuthenticated: null,
        verified: false,
        redirected: false,
        loading: true,
      };
    case CLEAR_EMAIL:
      return {
        userEmail: "",
        isAuthenticated: null,
        verified: false,
        redirected: false,
        temporaryPassword: false,
        message: "",
        loading: true,
      };
    default:
      return state;
  }
}
